<div class="contentcontainer">
  <rejectHistoryTable [data]="rejectHistory"></rejectHistoryTable>
  <recallHistoryTable [data]="recallHistory"></recallHistoryTable>
  <reopenHistoryTable [data]="reopenHistory"></reopenHistoryTable>
</div>
